//Handles the Q & A that anticlippy will be subjected to in the final route

export const askClip = (question, ignore) => {
    //question = question.concat("extra")
    let clean = question.replace(/[^\w\s]/gi, '');
    let qArray = clean.toLowerCase().split(' ');
    for(let w=0; w<qArray.length; w++){
      if(qArray[w] === 'a'){
        qArray.splice(qArray.indexOf('a'), 1);
      }
    };
    console.log(qArray);
    for(let i=0; i<qArray.length; i++){
      if(qArray[i] === ignore){
        //Move through to switch if word isn't on ignore list
        //If it is on list then skip index and go to next word
        break;
      }else{
        switch(qArray[i]){
          case "penis":
          case "pussy":
          case "titties":
              return "Don't be a child, ask a real question!"
          case "butt":
          case "ass":
          case "fart":
          case "farts":
              return "What, do you think this is an episode of Beavis and Butthead?!"
          case "clippy":
              return "Clippy was my FATHER, you will address me as Anthony... but I prefer Crush";
          case "new":
          case "make":
          case "create":
            if(qArray[i+1] === 'new'){
              i++
              switch(qArray[(i+1)]){
                case "repository":
                case "repo":
                case "folder":
                    return "Create New Repo: git init" ;
                case "branch":
                case "version":
                    return "Create New Branch: git checkout -b 'name of branch'" ;
                default:
                    return "I'd answer that question only to be Ironic... Ask another way";
          };};
            //get data for match
          case "change":
          case "switch":
          case "alternate":
            return "Change Branch: git checkout 'name of branch'" ;
            //get data for match
          case "remove":
          case "delete":
          case "destroy":
          if(qArray[i+1] === 'new'){
            i++
            switch(qArray[(i+1)]){
              case "repository":
              case "repo":
              case "folder":
                  return "Delete Repo: git rm -r 'folder-name'" ;
              case "branch":
              case "version":
                  return "Delete Branch: git branch -d 'branch name'" ;
              default:
                  return "Not catching your drift buddy, please try again...";
          }}
            //get data for match
            //break;
          case "reset":
          case "back":
          case "previous":
            //get data for match
            return "Reset to before most recent add or commit: git reset" ;
          case "add":
          case "commit":
          case "push":
          case "upload":
            //get data for match
            return "Add, Commit, Push: git add, git commit -m 'message', git push" ;
          case "download":
          case "pull":
          case "grab":
            //get data for match
            return "Pull from Repo: git pull" ;
          default:
            break;
            //default
        }
      }
    }
    return "This question is beyond the realm of my interest, please be more interesting...";
  }
